import { getProductCardStatusTags } from 'bundles/product-card/utils/getProductCardStatusTags';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

/**
 * Get badges using s12n page data
 *
 * @param pageData - The s12n page data
 * @returns Badges for the currently viewed product within ComparisonTableModule
 */
const getBadgesFromS12nPageData = (pageData: ConsumerSpecializationPageFieldsFragment): string[] => {
  const hasTopInstructor = pageData.instructors?.some((instructor) => instructor.isTopInstructor);

  const { tagNames } = getProductCardStatusTags({
    statusTags: [],
    slug: pageData.slug,
    hasTopInstructor,
  });

  return tagNames;
};

export default getBadgesFromS12nPageData;
